const CustomizationLinesSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="4" viewBox="0 0 7 4" fill="none">
      <line x1="6.5" y1="0.5" x2="0.5" y2="0.5" stroke="#D5D5D5" strokeLinecap="round" />
      <line x1="0.5" y1="3.5" x2="6.5" y2="3.5" stroke="#D5D5D5" strokeLinecap="round" />
    </svg>
  );
};

export default CustomizationLinesSvg;
